const { default: Sorter } = require("./sorter");

export default class PrevalenceSorter extends Sorter {
    constructor (prevalentSlug = "") {
        super();
        this.prevalentSlug = prevalentSlug;
    }

    setPrevalentSlug(slug = "") {
        this.prevalentSlug = slug;
    }

    /** @inheritdoc */
    sort(a, b) {
        const aSlug = a.dataset.slug;
        const bSlug = b.dataset.slug;

        if (aSlug === this.prevalentSlug) return -100;
        if (bSlug === this.prevalentSlug) return 100;

        return parseInt(a.dataset.index) - parseInt(b.dataset.index);
    }
}